// Navigation
export const SET_NAVIGATION = 'SET_NAVIGATION';
export const SET_CURRENT_PATH = 'SET_CURRENT_PATH';
export const SET_PREVIOUS_PATH = 'SET_PREVIOUS_PATH';
export const SET_IS_NAVIGATING = 'SET_IS_NAVIGATING';
export const SET_DIRECTION = 'SET_DIRECTION';



// WEBPACK FOOTER //
// ./src/store/reducers/navigation/actionTypes.js